import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import OfferBar from "./OfferBar";
import Header from "./Header";
import Hero from "./Hero";
import Services from "./Services";
import Products from "./Products";
import Footer from "./Footer";
import Gallery from "./Gallery";
import HamburgerMenu from "./HamburgerMenu";
import ChatBot from "./ChatBot";

import OpticalFrames from "./pages/OpticalFrames";
import BrandedLenses from "./pages/BrandedLenses";
import WatchCollections from "./pages/WatchCollections";

export default function App() {
  return (
    <Router>
      <Header />

      <Routes>
        {/* HOME */}
        <Route
          path="/"
          element={
            <>
              <OfferBar/>
              <Hero />
              <Services />
              <Products />
              <Gallery/>
              <HamburgerMenu/>
              <ChatBot/>
            </>
          }
        />

        {/* PRODUCT PAGES */}
        <Route path="/optical-frames" element={<OpticalFrames />} />
        <Route path="/branded-lenses" element={<BrandedLenses />} />
        <Route path="/watch-collections" element={<WatchCollections />} />
      </Routes>

      <Footer />
    </Router>
  );
}
